<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Account</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Account Group"
                :options="options"
                required
                placeholder="Select Group"
                @change="handleAccoutnGroup"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Account Name"
                class="mb-0"
                type="text"
                required
                placeholder="Account Name"
                @change="handleAccountName"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Username"
                class="mb-0"
                required
                placeholder="Username"
                @change="handleUsername"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Email"
                class="mb-0"
                type="email"
                placeholder="Email"
                @change="handlerEmail"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Password"
                class="mb-0"
                type="password"
                placeholder="Password"
                @change="handlePassword"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Position"
                :options="positions"
                required
                placeholder="Select Position"
                @change="handleAccountPosition"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                :disabled="!isFormValid || buttonDisable"
                :color="isFormValid ? 'success' : 'secondary'"
                class="float-right"
                @click="createUserAccount"
              >Create</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import jwt from "jsonwebtoken"

export default {
  name: "UserCreate",
 
  data() {
    return {
      accountData: {
        account_group: "",
        account_name: "",
        username: "",
        email: "",
        password: "",
        position: "",
      },
      buttonDisable: false,
      domain: process.env.VUE_APP_DOMAIN_URL,
      options: ["ADMINISTRATOR", "NPOS", "SALES", "HRD", "MARKETING", "QC", "COMMUNITY", "EXTERNAL"],
      positions: ["LEAD","STAFF"]
    };
  },
  mounted() {
    this.authentication()
  },
  computed: {
    isFormValid() {
      return (
        this.accountData.account_group !== "" &&
        this.accountData.account_name !== "" &&
        this.accountData.username !== "" &&
        this.accountData.password !== "" &&
        this.accountData.position !== ""
      );
    }
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/management/account" });
    },
    handleAccoutnGroup(event) {
      this.accountData.account_group = event.target.value;
    },
    handleAccountName(event) {
      this.accountData.account_name = event;
    },
    handleUsername(event) {
      this.accountData.username = event;
    },
    handlerEmail(event) {
      this.accountData.email = event;
    },
    handlePassword(event) {
      this.accountData.password = event;
    },
    handleAccountPosition(event) {
      this.accountData.position = event.target.value;
    },
    createUserAccount() {
      this.buttonDisable = true;
      axios
        .post(`${this.domain}/v1/account`, this.accountData, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Account Created`,
            showConfirmButton: false,
            timer: 2000
          });
          this.items = response.data;
          this.$router.push({ path: `/management/account` });
        })
        .catch(err => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message.id
          });
          this.buttonDisable = false;
        });
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    }
  }
};
</script>

<style scoped>
@import "./User.css";
</style>
